import { Container } from '@mui/material';
import styled from 'styled-components';

export const CustomContainer = styled(Container)`
  ${({ minheight }) => !!minheight && `min-height: ${minheight}`};
`;
